export const enum Environment {
  Development = 'dev',
  Sandbox = 'sandbox',
  Production = 'prod',
}
